module.exports = __webpack_public_path__ + "img/slide_8.39429cd7.png";